"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.toFontProperty = void 0;
exports.toFontProperty = function (text) {
    var fallbackString = text.fallbackFontFamilies && text.fallbackFontFamilies.length > 0
        ? ", " + text.fallbackFontFamilies.join(", ")
        : "";
    return text.fontStyle + " " + text.fontWeight + " "
        + (text.fontSize + "px " + text.fontFamily + fallbackString);
};
//# sourceMappingURL=toFontProperty.js.map